import { render, staticRenderFns } from "./CallHistory.vue?vue&type=template&id=be258b98&scoped=true&"
import script from "./CallHistory.vue?vue&type=script&lang=js&"
export * from "./CallHistory.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be258b98",
  null
  
)

export default component.exports